export const defaultState = () => ({
	allocation: null,
	editOnlyAllocationPayment: null,
	modalIsOpen: false,
	hasChanges: false,
});

export default defaultState();
